import { LensProvider as LensProvider$1, useCreateEncryptedComment as useCreateEncryptedComment$1, useCreateEncryptedPost as useCreateEncryptedPost$1, useEncryptedPublication as useEncryptedPublication$1 } from '@lens-protocol/react';
export * from '@lens-protocol/react';
import { useState } from 'react';
import { jsx } from 'react/jsx-runtime';
import { webCryptoProvider } from '@lens-protocol/gated-content/web';

function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}

function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

var LocalStorageProvider = /*#__PURE__*/function () {
  function LocalStorageProvider() {
    var _this = this;
    _classCallCheck(this, LocalStorageProvider);
    _defineProperty(this, "subscribers", new Map());
    _defineProperty(this, "onStorageEvent", function (event) {
      if (event.storageArea !== window.localStorage) {
        return;
      }
      if (event.key && _this.subscribers.has(event.key)) {
        var _this$subscribers$get;
        var subscribers = (_this$subscribers$get = _this.subscribers.get(event.key)) !== null && _this$subscribers$get !== void 0 ? _this$subscribers$get : [];
        subscribers.forEach(function (subscriber) {
          return subscriber(event.newValue, event.oldValue);
        });
      }
    });
  }
  _createClass(LocalStorageProvider, [{
    key: "getItem",
    value: function getItem(key) {
      return window.localStorage.getItem(key);
    }
  }, {
    key: "setItem",
    value: function setItem(key, value) {
      window.localStorage.setItem(key, value);
    }
  }, {
    key: "removeItem",
    value: function removeItem(key) {
      window.localStorage.removeItem(key);
    }
  }, {
    key: "subscribe",
    value: function subscribe(key, subscriber) {
      var _this2 = this;
      if (this.subscribers.has(key)) {
        var _this$subscribers$get2;
        (_this$subscribers$get2 = this.subscribers.get(key)) === null || _this$subscribers$get2 === void 0 ? void 0 : _this$subscribers$get2.push(subscriber);
      } else {
        this.subscribers.set(key, [subscriber]);
      }
      if (this.subscribers.size === 1) {
        this.listenToStorageEvent();
      }
      return {
        unsubscribe: function unsubscribe() {
          var _this2$subscribers$ge;
          var subscribers = (_this2$subscribers$ge = _this2.subscribers.get(key)) !== null && _this2$subscribers$ge !== void 0 ? _this2$subscribers$ge : [];
          var index = subscribers.indexOf(subscriber);
          if (index > -1) {
            subscribers.splice(index, 1);
          }
          if (subscribers.length === 0) {
            _this2.subscribers["delete"](key);
          }
          if (_this2.subscribers.size === 0) {
            _this2.stopListeningToStorageEvent();
          }
        }
      };
    }
  }, {
    key: "listenToStorageEvent",
    value: function listenToStorageEvent() {
      window.addEventListener('storage', this.onStorageEvent);
    }
  }, {
    key: "stopListeningToStorageEvent",
    value: function stopListeningToStorageEvent() {
      window.removeEventListener('storage', this.onStorageEvent);
    }
  }]);
  return LocalStorageProvider;
}();
function localStorage() {
  return new LocalStorageProvider();
}

var _excluded = ["config"];
var storage = localStorage();
function LensProvider(_ref) {
  var config = _ref.config,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(function () {
      return _objectSpread2(_objectSpread2({}, config), {}, {
        storage: storage
      });
    }),
    _useState2 = _slicedToArray(_useState, 1),
    resolvedConfig = _useState2[0];
  return /*#__PURE__*/jsx(LensProvider$1, _objectSpread2({
    config: resolvedConfig
  }, props));
}

function useBrowserEncryptionConfig() {
  var _useState = useState(function () {
      return {
        authentication: {
          domain: location.host,
          uri: location.href
        },
        provider: webCryptoProvider()
      };
    }),
    _useState2 = _slicedToArray(_useState, 1),
    encryption = _useState2[0];
  return encryption;
}

function useCreateEncryptedComment(args) {
  return useCreateEncryptedComment$1(_objectSpread2(_objectSpread2({}, args), {}, {
    encryption: useBrowserEncryptionConfig()
  }));
}

function useCreateEncryptedPost(args) {
  return useCreateEncryptedPost$1(_objectSpread2(_objectSpread2({}, args), {}, {
    encryption: useBrowserEncryptionConfig()
  }));
}

function useEncryptedPublication(args) {
  return useEncryptedPublication$1(_objectSpread2(_objectSpread2({}, args), {}, {
    encryption: useBrowserEncryptionConfig()
  }));
}

export { LensProvider, useCreateEncryptedComment, useCreateEncryptedPost, useEncryptedPublication };
